import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';

type ParticipantLoginFormProps = {
  redirectTo?: string;
  title?: string;
  description?: string;
};

export function ParticipantLoginForm({
  redirectTo = '/agenda',
  title = 'Mit Nachname und Zugangscode in deine Agenda',
  description = 'Hinweis zum Login: Feld Nachname: Meyer. Feld Zugangscode: MEYER.',
}: ParticipantLoginFormProps) {
  const [lastName, setLastName] = useState('');
  const [accessCode, setAccessCode] = useState('');
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: () => api.participantLogin(lastName, accessCode),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['me'] }),
        queryClient.invalidateQueries({ queryKey: ['agenda'] }),
        queryClient.invalidateQueries({ queryKey: ['my-bookings'] }),
      ]);
      navigate(redirectTo);
    },
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    mutation.mutate();
  }

  return (
    <>
      <div className="panel__header">
        <span className="eyebrow">Teilnehmerinnen-Login</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>

      <form className="stack" onSubmit={handleSubmit}>
        <label className="field">
          <span>Nachname</span>
          <input
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
            placeholder="z. B. Meyer"
            autoComplete="family-name"
          />
        </label>

        <label className="field">
          <span>Zugangscode</span>
          <input
            value={accessCode}
            onChange={(event) => setAccessCode(event.target.value.toUpperCase())}
            placeholder="z. B. MEYER"
            autoComplete="off"
          />
        </label>

        {mutation.error instanceof ApiError ? <p className="notice notice--error">{mutation.error.message}</p> : null}

        <button className="button" type="submit" disabled={mutation.isPending || accessCode.trim() === '' || lastName.trim() === ''}>
          {mutation.isPending ? 'Login läuft…' : 'Einloggen'}
        </button>
      </form>
    </>
  );
}
